<div class="container">
  <app-loan-agreement-component-text></app-loan-agreement-component-text>
  <mat-divider></mat-divider>
  <div style="margin-top: 15px;">
    <mat-checkbox #consentCheckbox style="display: inline;"></mat-checkbox>
    <div class="lender-consent-text" style="display: inline; color: #4a4a4a">
      I, hereby confirm that I have not invested more than ₹50,00,000 across all the P2P platforms in India, including
      www.finzy.com and hereby undertake to inform finzy if my aggregate exposure from investing, across all the P2P platforms in
      India, at any point of time is equivalent to ₹50,00,000, and understand and agree that finzy shall be entitled to take any
      and all actions as it may deem fit.
      <br/>

      I, hereby also agree that as and when my investment across all the P2P platforms in India including www.finzy.com exceed
      ₹10,00,000, I will provide finzy a net-worth certificate from a practicing Chartered Accountant in the
      <a [href]="getFileUrlByName('investorNetworthCertificate')">attached format</a>
      certifying that I have net-worth of more than ₹50,00,000.
      <br/>

      I, hereby also confirm that I have understood all the risks associated with the lending transactions and finzy does not
      assure return of principal/payment of interest and there exists a likelihood of loss of the entire principal in case of
      default by a borrower.
    </div>
  </div>
  <div class="text-center" style="width: 100%; margin-top: 10px;">
    <button mat-flat-button class="primary" [disabled]="!consentCheckbox.checked"
            (click)="onConsentGranted()"
            *ngIf="!shouldShowLoader">
      Accept agreement and continue
    </button>
    <mat-spinner [diameter]="35" *ngIf="shouldShowLoader"
                 style="margin-left: auto; margin-right: auto;">
    </mat-spinner>
  </div>
</div>